import React from 'react';

import 'bootstrap-daterangepicker/daterangepicker.css';
import { Tab } from 'react-bootstrap';
import './booktable.css';

import BookTable from './BookTable';

const Bookings = () => {
  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <BookTable />
      </Tab.Container>
    </>
  );
};
export default Bookings;
